var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"list-amenities",class:{ active: _vm.isActive },on:{"click":_vm.changeIcon}},[(_vm.icon)?_c('AtomsCommonAtomIcon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.label))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }